import React from 'react';
import styled from 'styled-components';
import Title from '@/components/Title';
import Paragraph from '@/components/Paragraph';
import { graphql } from 'gatsby';

import Container from '@/components/Container';
import BlockWrapper from '@/components/BlockWrapper';
import CTAImageLeftOrRight, {
  CTAImageLeftOrRightData,
} from '@/components/CTAImageLeftOrRight';
import { isDarkTheme } from '@/utils/StyleUtils';
import { DefaultPaths } from '../Page';

const ImagesContent = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const BlockContent = styled.div`
  text-align: center;
  margin-bottom: 7rem;
`;

type Props = {
  id: string;
  title: string;
  subtitleMultipleLine: {
    subtitle: string;
  };
  backgroundColor: string;
  alignmentFirstImage: {
    alignmentFirstImage: string;
  };
  ctas: Array<CTAImageLeftOrRightData>;
  defaultPaths?: DefaultPaths;
};
const ImagesSwitchingSidesBlock: React.FC<Props> = ({
  id,
  title,
  subtitleMultipleLine,
  backgroundColor,
  alignmentFirstImage,
  ctas,
  defaultPaths,
}) => {
  const dark = isDarkTheme(backgroundColor);
  let imageLeft = alignmentFirstImage?.alignmentFirstImage === 'Left';
  return (
    <BlockWrapper id={id} color={backgroundColor}>
      <Container>
        {(title || subtitleMultipleLine) && (
          <BlockContent>
            {title && (
              <Title size='xl' level='h2' margin='0 0 2rem' lightColor={dark}>
                {title}
              </Title>
            )}
            {subtitleMultipleLine && (
              <Paragraph
                color={dark ? 'White' : 'GreyBlue'}
                margin='0 0 1.5rem'
                weight='semiBold'
              >
                {subtitleMultipleLine.subtitle}
              </Paragraph>
            )}
          </BlockContent>
        )}
        <ImagesContent>
          {React.Children.toArray(
            ctas.map((card) => {
              imageLeft = !imageLeft;
              return CTAImageLeftOrRight({
                ...card,
                left: !imageLeft,
                dark: dark,
                defaultPaths: defaultPaths,
              });
            }),
          )}
        </ImagesContent>
      </Container>
    </BlockWrapper>
  );
};

export default ImagesSwitchingSidesBlock;
export const imagesSwitchingSidesBlockFragmentQuery = graphql`
  fragment ImagesSwitchingSidesFragment on ContentfulImagesSwitchingSidesBlock {
    id
    __typename
    title
    subtitleMultipleLine: subtitle {
      subtitle
    }
    alignmentFirstImage {
      alignmentFirstImage
    }
    backgroundColor
    ctas: CTAs {
      ...CTAImageLeftOrRightFragment
    }
  }
`;
